import { render, staticRenderFns } from "./ShowInsurer.vue?vue&type=template&id=be2b766c&"
import script from "./ShowInsurer.vue?vue&type=script&lang=js&"
export * from "./ShowInsurer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports